import React from 'react';
import { TrophyIcon } from 'lucide-react';
import type { WinnerRecord } from '../types/session';
interface WinnersListProps {
  winners: WinnerRecord[];
  /** Lowercased name of the viewer, so their own wins stand out. */
  mine: string;
  showHeading?: boolean;
  className?: string;
}
const time = (ms: number | null) => ms ? new Date(ms).toLocaleTimeString([], {
  hour: 'numeric',
  minute: '2-digit'
}) : '';
export function WinnersList({
  winners,
  mine,
  showHeading = true,
  className = ''
}: WinnersListProps) {
  return <section aria-label="Winners so far" className={`flex min-h-0 flex-col ${className}`} data-id="element-339" data-mp="6cagtmv43tyv">
      {showHeading && <div className="flex items-baseline justify-between gap-3 border-b border-line pb-2" data-id="element-340" data-mp="1ixslduchp6n">
          <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-341" data-mp="3sr3bugj8s3yd">
            Winners so far
          </h3>
          <span className="text-xs tabular-nums text-muted" data-id="element-342" data-mp="pamrxe5l3dx3">{winners.length}</span>
        </div>}

      {winners.length === 0 ? <p className="py-6 text-sm text-muted" data-id="element-343" data-mp="189vhbvhb4vws">
          No one has been drawn yet — winners appear here the moment they are picked.
        </p> : <ol className="min-h-0 flex-1 divide-y divide-line/70 overflow-y-auto pr-1" data-id="element-344" data-mp="zgiea0pj4dwz">
          {winners.map((w, i) => {
        const isMe = w.name.trim().toLowerCase() === mine;
        return <li key={w.id} className="flex items-center gap-3 py-2.5" data-id="element-345" data-mp="pim4pdc8pr0z" data-mpi={i}>
                <span className="w-6 shrink-0 text-right text-xs tabular-nums text-muted" data-id="element-346" data-mp="pkfc4uuogfa1">
                  {winners.length - i}
                </span>
                <span className={`min-w-0 flex-1 truncate text-sm ${isMe ? 'font-semibold text-gold' : 'text-body'}`} data-id="element-347" data-mp="gippe2bqq4il">
                  {w.name}
                  {isMe && <span className="ml-2 text-xs text-muted" data-id="element-348" data-mp="2awgseizkdq52">you</span>}
                </span>
                {i === 0 && <TrophyIcon className="h-3.5 w-3.5 shrink-0 text-gold" aria-label="Most recent" data-id="element-349" data-mp="3nu7lr0ofb8u6" />}
                <span className="shrink-0 text-[11px] tabular-nums text-muted" data-id="element-350" data-mp="3ittcjfb35suk">
                  {time(w.at)}
                </span>
              </li>;
      })}
        </ol>}
    </section>;
}